import Router from 'vue-router';
import Components from '@/views/Components.vue';
import CurrentTariff from '@/views/CurrentTariff.vue';
import QuoteResults from '@/views/QuoteResults.vue';
import TariffDetails from '@/views/TariffDetails.vue';
import PersonalDetails from '@/views/PersonalDetails.vue';
import SwitchComplete from '@/views/SwitchComplete.vue';
import CarbonOffsetExisting from '@/views/CarbonOffsetExisting.vue';
import CarbonOffset from '@/views/CarbonOffset.vue';
import CarbonOffsetProcess from '@/views/CarbonOffsetProcess.vue';
import ErrorPage from '@/views/ErrorPage.vue';

import store from '../store';

const router = new Router({
  routes: [
    // {
    //   path: '/components',
    //   name: 'components',
    //   component: Components
    // },
    {
      path: '*',
      redirect: '/switch/home-energy'
    },
    {
      path: '/switch/home-energy/:refererBranch?/:reference?',
      name: 'currentTariff',
      meta: {
        title: 'Current Tariff'
      },
      component: CurrentTariff
    },
    {
      path: '/results/home-energy',
      name: 'quoteResults',
      meta: {
        title: 'Results'
      },
      component: QuoteResults
    },
    {
      path: '/tariff-details/:tariffId',
      name: 'tariffDetails',
      meta: {
        title: 'Tariff Details'
      },
      component: TariffDetails
    },
    {
      path: '/details',
      name: 'personalDetails',
      meta: {
        title: 'Personal Details'
      },
      component: PersonalDetails
    },
    {
      path: '/switch-complete',
      name: 'switchComplete',
      meta: {
        title: 'Switch Complete'
      },
      component: SwitchComplete
    },
    {
      path: '/carbon-offset',
      name: 'carbonOffset',
      meta: {
        title: 'Carbon Offset'
      },
      component: CarbonOffset
    },
    {
      path: '/carbon-offset-process/:id?:oid?:c?',
      props: true,
      name: 'carbonOffsetProcess',
      meta: {
        title: 'Carbon Offset Process'
      },
      component: CarbonOffsetProcess
    },
    // {
    //   path: '/carbon-offset-existing',
    //   name: 'carbonOffsetExisting',
    //   meta: {
    //     title: 'Carbon Offset Existing'
    //   },
    //   component: CarbonOffsetExisting
    // },
    {
      path: '/error/:status',
      name: 'error',
      meta: {
        title: 'Error Page'
      },
      component: ErrorPage
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach(async (to, from, next) => {
  if (to.name != 'error') {
    await store.dispatch('token/getToken');
  }

  if (await store.dispatch('personal_details_switch_plan/switched', to.name)) {
    next({ name: 'switchComplete' })
  } else {
    store.dispatch('tracing/setPage', to.meta.title);
    if (to.params) store.dispatch('tracing/addAction', { name: 'Params', value: to.params });
    store.dispatch('tracing/addAction', { name: 'Action', value: 'Viewed' });
    await store.dispatch('tracing/saveActions');
    next()
  }
})

router.afterEach((to, from) => store.dispatch('history/updatePreviousRoute', from));

export default router;
